var w = Object.defineProperty;
var E = (t, e, n) => e in t ? w(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var _ = (t, e, n) => E(t, typeof e != "symbol" ? e + "" : e, n);
import { jsx as d } from "react/jsx-runtime";
import { createContext as f } from "react";
const v = "@gjensidige/core-analytics", h = "16.1.4", r = "not-set", c = "application_module", u = "event_module", l = {
  [c]: r,
  application_name: r,
  business_area: r,
  customer_segment: r,
  event_source: v,
  event_version: h
}, s = ({ options: t }, e = {}) => (t[c] === t[u] && e[c] && (e[u] = e[c]), Object.assign(t, m({ ...t, ...e })));
class j {
  constructor(e) {
    _(this, "options", { ...l });
    s(this, e);
  }
  setOptions(e = {}) {
    s(this, e);
  }
  trackEvent(e, n) {
    k(e, s(this, n));
  }
  trackEcommerceEvent(e, n) {
    T(e, s(this, n));
  }
  trackView(e) {
    P(s(this, e));
  }
  trackEcommerceView(e) {
    $(s(this, e));
  }
}
const k = (t, e, n) => i({ ...e, ...t }, "link", n), T = (t, e, n) => i({ ...e, ...t }, "link", n), P = (t) => i(t, "view"), $ = (t) => i(t, "view"), O = f({
  options: { ...l }
}), V = ({ options: t, ...e }) => /* @__PURE__ */ d(O.Provider, { value: { options: t }, ...e });
let p = 0;
function i(t = {}, e, n) {
  var a;
  const o = (a = window.utag) == null ? void 0 : a[e].bind(window.utag);
  o ? n ? o(m(t), n) : o(m(t)) : p < 10 ? setTimeout(() => i(t, e), 100, p++) : console.error(`window.utag.${e} not found `, t);
}
function m(t) {
  const e = { ...l };
  return Object.entries(t).forEach(([n, o]) => {
    const a = n === "eventLabel" || n === "eventStatus", g = n.replace(/[A-Z]/g, "_$&").toLowerCase();
    a && o && (o = `${o}`.toLowerCase().split(" ").join("-")), e[g] = o;
  }), {
    ...e,
    [u]: e[u] || e[c],
    page_pathname: e.page_pathname || C(e),
    measure_source: e.event_source,
    measure_version: e.event_version
  };
}
function C(t) {
  return `${window.location.pathname.replace(/\/$/, "")}/${t.application_name}/${t[c]}/${t.scenario_name}/${t.scenario_step}`.replace(/\/(undefined|null|not-set)/g, "").replace("/Din+side/", "/Din-side/");
}
export {
  l as DEFAULT_CONTEXT_TRACKING,
  j as Tracking,
  O as TrackingContext,
  V as TrackingProvider,
  T as trackEcommerceEvent,
  $ as trackEcommerceView,
  k as trackEvent,
  P as trackView
};
//# sourceMappingURL=index.js.map
